import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M2.52985 2.38C3.18707 2.38 3.71985 1.84722 3.71985 1.19C3.71985 0.532784 3.18707 0 2.52985 0C1.87263 0 1.33984 0.532784 1.33984 1.19C1.33984 1.84722 1.87263 2.38 2.52985 2.38Z"
        fill={fill} // "#FFDC2E"
      />
      <path
        d="M2.53003 10.33C3.92731 10.33 5.06 9.19733 5.06 7.80005C5.06 6.40277 3.92731 5.27002 2.53003 5.27002C1.13275 5.27002 0 6.40277 0 7.80005C0 9.19733 1.13275 10.33 2.53003 10.33Z"
        fill={fill} // "#FFDC2E"
      />
      <path
        d="M67.5899 2.38C68.2471 2.38 68.7799 1.84722 68.7799 1.19C68.7799 0.532784 68.2471 0 67.5899 0C66.9327 0 66.3999 0.532784 66.3999 1.19C66.3999 1.84722 66.9327 2.38 67.5899 2.38Z"
        fill={fill} // "#FFDC2E"
      />
      <path
        d="M67.5901 10.33C68.9874 10.33 70.1201 9.19733 70.1201 7.80005C70.1201 6.40277 68.9874 5.27002 67.5901 5.27002C66.1928 5.27002 65.0601 6.40277 65.0601 7.80005C65.0601 9.19733 66.1928 10.33 67.5901 10.33Z"
        fill={fill} // "#FFDC2E"
      />
    </g>
  )
}
